module.exports = __webpack_public_path__ + "img/10no-ten.f65d3f44.jpg";